import { Divider, Grid, Paper, useTheme } from '@mui/material'
import React from 'react'
import { TextBold, TextRegular, TextSemiBold } from '../TextStyling'
import appassets from '../../utils/appassets'
import { colorWithOpacity, formatNumber } from '../../utils/AppHelper'
import { currencySymbol } from '../../utils/AppConstants'
import WalletIcon from '@mui/icons-material/Wallet'

export default function TotalEarnings ({ data }) {
  const theme = useTheme()

  return (
    <Paper elevation={3} style={{ borderRadius: '16px' }}>
      <Grid container>
        <Grid
          item
          xs={9}
          style={{ padding: '16px', display: 'flex', alignItems: 'center' }}
        >
          <Grid container>
            <Grid item xs={12}>
              <TextBold style={{ fontSize: '16px' }}>Total Earnings</TextBold>
            </Grid>
            <Grid item xs={12}>
              <TextSemiBold>
                {currencySymbol}
                {formatNumber(data)}
              </TextSemiBold>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid
            item
            xs={2}
            style={{
              borderRadius: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: colorWithOpacity(
                theme.palette.primary.main,
                0.1
              ),
              padding: '1rem 1.5rem',
              margin: '1rem'
            }}
          >
            {/* <img src={appassets.recruiterSignupDollar} alt={'img'} /> */}
            <WalletIcon style={{ color: theme.palette.primary.main }} />
          </Grid>
        </Grid>
        <Divider style={{ width: '100%' }} />
        <Grid item xs={12} style={{ padding: '16px', lineHeight: '16px' }}>
          <TextRegular style={{ color: theme.palette.text.disabled }}>
            Earnings will show here with in 2 working days.
          </TextRegular>
        </Grid>
      </Grid>
    </Paper>
  )
}
